<div style="display: flex; align-items: center; justify-content: space-between;">
  <h2 style="margin-top: 20px !important;" class="cpo-section-title">Manage Roles</h2>
  <!-- @if (hasWriteAccess) { <button style="cursor: pointer;" class="btn-core toolbar-button" (click)="create()">Add Role</button> } -->
</div>

<table [showLoadingSpinner]="loading" [hidden]="selectedRole != undefined || editingRole" class="cpo-selectable-table">
  <thead>
    <tr class="cpo-selectable-table__header-row">
      <th class="no-sort">Role Name</th>
      <th class="no-sort">Internal Name</th>
    </tr>
  </thead>
  @for (
    item of allRoles;
    track item.name;
    let even = $even;
    let odd = $odd
  ) {
    @if (item.name != undefined) {
      <tr
        id="trsummary_{{ item.name }}"
        [ngClass]="{ even: even, odd: odd }"
        class="cpo-selectable-table__row"
        style="cursor: pointer;"
        (click)="select(item)"
      >
        <td style="width: 20%">{{ item.friendlyName }}</td>
        <td style="width: 20%">{{ item.name }}</td>
      </tr>
    }
  }
</table>

<div [hidden]="!selectedRole">
  <app-edit-role
    [role]="selectedRole"
    (cancelled)="handleRoleCancelled()"
    (saved)="handleRoleSaved($event)"
  ></app-edit-role>
</div>
